import React, { useEffect, useState } from "react";
import TopNavigation from "../../../components/TopNavigation";
import ApiUtils from "../../../utils/api_utils";
import moment from "moment/moment";
import * as Assets from "../../../utils/svg_assets";
import { Row, Col } from "react-bootstrap";
import { Base } from "../../../components/RootLayout";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import "./style.scss";

const PollingComment = (props) => {
  const params = useParams();
  const { getCommentList, postComment } = props;
  const [dataComment, setDataComment] = useState([]);
  const [input, setInput] = useState("");

  const filterCommentById = (data) => {
    let filterProcess = data.filter((a) => a?.survey == params?.pollingId);
    setDataComment(filterProcess);
  };

  const getComment = async () => {
    const { status, data } = await getCommentList();
    if (status == 200) {
      filterCommentById(data);
    }
  };

  const handleClickPost = async () => {
    if (input) {
      let payload = {
        data: {
          comment: input,
          survey: params?.pollingId,
        },
      };

      const { status, data } = await postComment(payload);
      if (status == 200) {
        setInput("");
        getComment();
      }
    }
  };

  useEffect(() => {
    getComment();
  }, []);

  return (
    <Base>
      <TopNavigation
        titlePage={`Comments (${dataComment?.length})`}
        toPath={-1}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="detail-comments-wrapper">
        {dataComment &&
          dataComment.map((a, index) => (
            <Row className="list mb-3" key={index}>
              <Col
                xs={2}
                sm={2}
                md={2}
                className="d-flex justify-content-center"
              >
                <div className="image-wrapper">
                  <img
                    src={ApiUtils.validateImgUrl({ url: a?.creator?.image })}
                    alt="logo_image"
                  />
                </div>
              </Col>
              <Col>
                <Row>
                  <Col>
                    <span className="text-small">{a?.creator?.name}</span>
                  </Col>
                  <Col
                    className="d-flex justify-content-end"
                    xs={5}
                    sm={5}
                    md={4}
                  >
                    <span className="text-small">
                      {moment(a?.created).format("YYYY-MM-DD")}
                    </span>
                  </Col>
                </Row>
                <Col>
                  <span className="comment">{a?.comment}</span>
                </Col>
              </Col>
            </Row>
          ))}
        <div className="comment-input-position">
          <div className="wrapper">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              type="text"
              placeholder="Comment..."
              className="comment"
            />
            <div className="button-post" onClick={handleClickPost}>
              <span>POST</span>
            </div>
          </div>
        </div>
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getCommentList: dispatch.PollingSM.getCommentList,
  postComment: dispatch.PollingSM.postComment,
});

export default connect(mapStateToProps, mapDispatchToProps)(PollingComment);
